export default "__VITE_ASSET__Ci8PALWv__"